module.exports = [{"test":{"settings":"/test/static/settings.werkgeluk_test.json","questions":"/test/static/questions.werkgeluk_test.json","results":"/test/static/results.werkgeluk_test.json","collection":"werkgeluk_test"}}]


//////////////////
// WEBPACK FOOTER
// ./data/projects.json
// module id = 2
// module chunks = 0